import { configureStore } from '@reduxjs/toolkit';
import spinnerReducer from './slices/spinnerSlice';
import awmacReducer from './slices/awmacSlice';

export const store = configureStore({
  reducer: {
    spinner: spinnerReducer,
    awmac: awmacReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
